import { render, staticRenderFns } from "./Drill.vue?vue&type=template&id=dd126880&scoped=true&"
import script from "./Drill.vue?vue&type=script&lang=js&"
export * from "./Drill.vue?vue&type=script&lang=js&"
import style0 from "./Drill.vue?vue&type=style&index=0&id=dd126880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd126880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
